export const NAV_CHART_LINE_COLOR = '#3c8a95'; // seafoam-500
export const NAV_CHART_AREA_FILL = '#d7ecef'; // seafoam-100
// Same as the account page's NetValueCard net-invested line (no palette token; between gold-200 and gold-300).
export const NAV_CHART_NET_INVESTED_LINE_COLOR = '#b59963';
export const NAV_CHART_GRID_COLOR = '#e5e7eb'; // gray-200
export const NAV_CHART_AXIS_TICK_COLOR = '#9ca3af'; // gray-400

// Cycled per benchmark in list order; kept distinct from the market-value line (seafoam-500).
// Benchmarks are dashed, which sets them apart from the solid gold net-invested line.
export const NAV_CHART_BENCHMARK_LINE_COLORS = [
    '#946a3e', // gold-400
    '#c65b57', // red-200
    '#2c656d', // seafoam-600
    '#c7a37b', // gold-200
    '#9c251e', // red-400
];

export const NAV_CHART_LINE_WIDTH = 1.5;
// Dash pattern for comparison lines that are not part of the account's own history.
export const NAV_CHART_DASH_PATTERN = '5 4';
export const NAV_CHART_AXIS_TICK_FONT_SIZE = 11;
// Short month/year x-axis tick label, e.g. "Jul '26" (formatDate parses YYYY-MM-DD or ISO).
export const NAV_CHART_MONTH_LABEL_FORMAT = "MMM ''yy";
// Y-axis headroom on the Market Value chart, as a fraction of the plotted range (highest value
// minus max(lowest value, 0)), added below the floor and above the ceiling. Range-relative, not
// value-relative, so a portfolio that moves 3% still fills the plot instead of drawing a flat line.
export const NAV_CHART_Y_PADDING = 0.05;
